import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ContainerBox from "./common/containerBox.component";
import FormText from "./form/formText.component";
import { stateProps } from "../types";
import { changeLanguage } from "../actions/index";
import FormLanguageInput from "./form/formLanguageInput.component";

// const languagesData = [
//   { id: 1, value: "සිංහල" },
//   { id: 2, value: "தமிழ்" },
//   { id: 3, value: "English" },
// ];

const Languages: React.FC = () => {
  const dispatch = useDispatch();

  const languages = useSelector(
    (state: { router: History; doctorInfo: stateProps }) => state.doctorInfo.languages
  );

  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, name } = event.target;
    const updateApplyLanguages: {
      id: number;
      name: string;
      status?: boolean;
    }[] = languages.map((lanugage) => {
      if (lanugage.id === parseInt(name)) {
        lanugage.status = checked;
      }
      return lanugage;
    });
    dispatch(changeLanguage(updateApplyLanguages));
  };

  return (
    <React.Fragment>
      <ContainerBox>
        <FormText number={"06"} title={"What languages do you consult in?"} />
        <FormLanguageInput onInputChange={onInputChange} applyLanguages={languages} />
      </ContainerBox>
    </React.Fragment>
  );
};

export default Languages;
